export default {
    SLIDE_MENU: 'slide_menu',
    INSERT_MENU: 'insert_menu',
    SHAPE_MENU: 'shape_menu',
    CONTEXT_MENU: 'context_menu',
    UNIVERSES_MENU: 'universes_menu',
    ALL_MENUS: 'all_menus'
};



/** WEBPACK FOOTER **
 ** ./src/constants/MenuType.js
 **/